<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :showSource="true" granularity="week" @on-selected="onPanelSelect"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import columnChartOptions from "@/config/charts/column";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null,
      selectedPhaseLocal: null
    };
  },
  computed: {
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    }
  },
  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(columnChartOptions));
    this.chartOptions.title.text = this.$lang.charts.daily_total_reactive_energy;
    this.chartOptions.yAxis.labels.format = "{value} kVArh";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} kVArh</b><br/>";
    this.chartOptions.series = [
      {
        name: this.$lang.charts.quadrant + " 1",
        type: "column",
        marker: {
          enabled: false
        },
        dashStyle: "Solid",
        data: []
      },
      {
        name: this.$lang.charts.quadrant + " 2",
        type: "column",
        marker: {
          enabled: false
        },
        visible: false,
        dashStyle: "Solid",
        data: []
      },
      {
        name: this.$lang.charts.quadrant + " 3",
        type: "column",
        marker: {
          enabled: false
        },
        visible: false,
        dashStyle: "Solid",
        data: []
      },

      {
        name: this.$lang.charts.quadrant + " 4",
        type: "column",
        marker: {
          enabled: false
        },
        dashStyle: "Solid",
        data: []
      }
    ];
    this.chartOptions.yAxis.type = this.selectedyAxisType;
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
        this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );
    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  methods: {
        onPanelSelect(data) {
      this.$nextTick(() => {
        this.getAPIData(data);
      });
    },

    getAPIData(selected) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + ( (selected.device.type === 12) ? "/energyEY" : "/energy"),
        data: {
          token: getSelectedDeviceToken(selected.device.mac),
          data: "Q1,Q2,Q3,Q4",
          phase: "CUM",
          from: selected.date.from,
          to: parseInt(selected.date.to) + 1,
          period: "DAY",
          format: "H",
          source: selected.source
        },
        withCredentials: true
      })
        .then(response => {
            chart.series[0].setData(response.data.data.Q1.CUM, false, false, false);
            chart.series[1].setData(response.data.data.Q2.CUM, false, false, false);
            chart.series[2].setData(response.data.data.Q3.CUM, false, false, false);
            chart.series[3].setData(response.data.data.Q4.CUM, false, false, false);

            chart.xAxis[0].setExtremes(null, null, true);
        })
        .catch(error => {
          if (error.response.data.code === 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            chart.series[0].setData([]);
            chart.series[1].setData([]);
            chart.series[2].setData([]);
            chart.series[3].setData([]);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>